import { BurgerScene, IngredientsEnum } from "../../scenes/BurgerScene"
import { TutorialHand } from "../TutorialHand";
import { IngredientConfig } from "./IngredientSpawner";

const CONFIG = {
    depth: 100,
    handMoveTime: 1500,

    hintCountdown: {first: 2000, general: 4000},

    generalLocations: {
    center: {x: 427, y: 240}, // Copied from BurgerManagerConfig 
    serve: {x: 725, y: 325},
    recycle: {x: 114, y: 144},
    },
}

export class BurgerHintSystem {
    private scene : BurgerScene;
    private ingredientHands : {ingredient: IngredientsEnum, hand: TutorialHand}[];
    private serveHand : TutorialHand;
    private recycleHand: TutorialHand;

    private isDragging: boolean;
    private isHintActive: boolean;
    private gameEnded: boolean;
    private activeHand !: TutorialHand

    private hintCountdown : number = CONFIG.hintCountdown.first;

    constructor(scene: BurgerScene, ingredients: IngredientConfig[]){
        this.scene = scene;

        //Create tutorial hands
        this.ingredientHands = this.createIngredientHands(ingredients);
        this.serveHand = new TutorialHand({
                            spawnPos: CONFIG.generalLocations.serve,
                            depth: CONFIG.depth,
                        }, this.scene);

        this.recycleHand = new TutorialHand({
                            spawnPos: CONFIG.generalLocations.recycle,
                            depth: CONFIG.depth,
                        }, this.scene);

        this.isDragging = false;
        this.isHintActive = false;
        this.gameEnded = false;

        this.resetCountdown(2000);
    }

    private createIngredientHands(ingredients: IngredientConfig[]){
        let ingredientHands: {ingredient: IngredientsEnum, hand: TutorialHand}[] = [];
        ingredients.forEach(ingConf => {
            let hand = new TutorialHand({
                spawnPos: ingConf.spawn,
                moveAnim: {
                    movePos: CONFIG.generalLocations.center,
                    time: CONFIG.handMoveTime,
                },
                depth: CONFIG.depth,
            }, this.scene);

            ingredientHands.push({ingredient: ingConf.ingredient, hand: hand});

        });
        return ingredientHands;
    }

    public onUpdate(delta: number){
        if (this.isDragging || this.isHintActive || this.gameEnded){
            return;
        }
        this.updateCountdown(delta)
    }

    private updateCountdown(delta: number){
        this.hintCountdown -= delta;

        if (this.hintCountdown <= 0){
            this.activateNextHint();
        }
    }

    private resetCountdown(extraTime: number){
        this.hintCountdown = extraTime + CONFIG.hintCountdown.first; //TODO: differentiate between first burger and next burgers!!
    }

    private activateNextHint(){ 
        this.isHintActive = true;

        if (this.activeHand) this.activeHand.hide();
        this.activeHand = this.getNextHand();
        this.activeHand.show();
    }

    getNextHand(){
        let hand;
        if (this.scene.isBurgerCompleted()){     
            hand = this.serveHand;
        } else {
            if (this.scene.isBurgerCorrect()){
                let nextIngredient = this.scene.getNextIngredient();
                hand = this.ingredientHands.filter( ih => ih.ingredient === nextIngredient)[0].hand;
            } else {
                hand = this.recycleHand;
            }
        }

        return hand;
    }

    private deactivateCurrentHint(extraTime: number = 0){
        this.isHintActive = false;
        if (this.activeHand) this.activeHand.hide();
        this.resetCountdown(extraTime);
    }


    public handleDrag(start: boolean){
        this.isDragging = start;

        if (start){
            this.deactivateCurrentHint();
        }
    }

    public handleEndGame(){
        this.gameEnded = true;
        this.deactivateCurrentHint();
    }

    public handleButtonClick(){
        this.deactivateCurrentHint(1500);
    }
}